import { observer } from 'mobx-react-lite'
import { useMemo, useState } from 'react'
import classNames from 'classnames'
import { Button } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { TestSMS } from 'widgets/TestSMS'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'
import { ReviewBroadcastAction } from 'pages/broadcasts/ui/BroadcastView/ui/ReviewBroadcast/ReviewBroadcastAction'
import { broadcastActionsStore } from 'pages/broadcasts/ui/BroadcastActions'
import styles from './styles.module.scss'

export const BroadcastActions = observer(() => {
  const { broadcastSMSStore, ringlessMessageFieldStore, type, number, testSMSParams } =
    useBroadcastViewContext()
  const onCancel = () => {
    uiStore.changeRoute({
      path: 'broadcasts/all',
    })
  }
  const [isTest, showTest] = useState(false)

  const testSMSDisabled = useMemo(() => {
    const isNoNumberId = !number?.id

    if (isNoNumberId && type !== 'rcs') return true

    if (type === 'ringless') {
      return !ringlessMessageFieldStore.attachment
    }

    const isMessageEmpty =
      !broadcastSMSStore.messageDataParams.message.trim().length &&
      !broadcastSMSStore.messageDataParams.media_url.length
    const isError = broadcastSMSStore.isError
    const isLoadingAttachment = broadcastSMSStore.messageFieldStore.loadingAttachment

    return isError || isMessageEmpty || isLoadingAttachment
  }, [
    broadcastSMSStore.messageFieldStore.isAttachmentsCountLimitError,
    broadcastSMSStore.messageFieldStore.loadingAttachment,
    broadcastSMSStore.isError,
    broadcastSMSStore.messageDataParams.message,
    broadcastSMSStore.messageDataParams.media_url,
    ringlessMessageFieldStore.attachment,
    number?.id,
    type,
  ])

  return (
    <div className={classNames(styles.wrap, { [styles.isTest]: isTest })}>
      {!isTest && (
        <>
          <ReviewBroadcastAction />
          <Button text={'Cancel'} contained={'secondary'} onClick={onCancel} />
          <div />
        </>
      )}

      <TestSMS
        disabled={testSMSDisabled}
        params={testSMSParams}
        request={broadcastActionsStore.onTestSMSBroadcast}
        onToggleShowTest={showTest}
      />
    </div>
  )
})
